import { createSlice } from "@reduxjs/toolkit";
const today = new Date();
export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    dates: {
      daily: {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        day: today.getDate(),
      },
      monthly: {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        day: today.getDate(),
      },
      yearly: {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        day: today.getDate(),
      },
      custom: {
        from: null,
        to: null,
      },
    },
    editTarget: {
      type: null,
      volume: {
        target: null,
      },
      fee: {
        target: null,
      },
      isOpen: false,
    },
  },
  reducers: {
    setDaily: (state, action) => {
      state.dates.daily = action.payload;
    },
    setMonthly: (state, action) => {
      state.dates.monthly = action.payload;
    },
    setYearly: (state, action) => {
      state.dates.yearly = action.payload;
    },
    setCustom: (state, action) => {
      state.dates.custom = action.payload;
    },
    setCustomFrom: (state, action) => {
      state.dates.custom.from = action.payload;
    },
    setCustomTo: (state, action) => {
      state.dates.custom.to = action.payload;
    },
    setEditTarget: (state, action) => {
      state.editTarget = action.payload;
    },
  },
});

export const {
  setDaily,
  setMonthly,
  setCustom,
  setCustomFrom,
  setCustomTo,
  setYearly,
  setEditTarget,
} = dashboardSlice.actions;
